import { render } from "./AppHeaderBack.vue?vue&type=template&id=35d6cff3&scoped=true"
import script from "./AppHeaderBack.vue?vue&type=script&lang=js"
export * from "./AppHeaderBack.vue?vue&type=script&lang=js"

import "./AppHeaderBack.vue?vue&type=style&index=0&id=35d6cff3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d6cff3"]])

export default __exports__